module.exports = __webpack_public_path__ + "media/images/favicons/96x96-c9d04266cc151e92e6ebdeb7ba14d603.png";